<template>
    <div class="bg-body-light">
        <div class="content content-full">
            <div class="d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center">
                <h1 class="flex-sm-fill font-size-h2 font-w400 mt-2 mb-0 mb-sm-2">{{title}}</h1>
                <nav class="flex-sm-00-auto ml-sm-3" aria-label="breadcrumb">
                    <ol class="breadcrumb" >
                        <li v-for="(item, $index) in items" :class="['breadcrumb-item', {active: lastItem($index)}]" :aria-current="{page: lastItem($index)}">{{item}}</li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		// name: "ui-breadcrumb",
        props: {
		    items: Array,
            title: String
        },
        methods: {
		    lastItem : function(index) {
		        return (index + 1 ) === this.items.length;
            }
        }
	}
</script>
